import { render, staticRenderFns } from "./course copy.vue?vue&type=template&id=491c2b56"
import script from "./course copy.vue?vue&type=script&lang=js"
export * from "./course copy.vue?vue&type=script&lang=js"
import style0 from "./course copy.vue?vue&type=style&index=0&id=491c2b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports